<template>
  <v-dialog v-model="model" max-width="400">
    <v-card>
      <v-card-title class="px-5" style="color: red">Warning</v-card-title>
      <v-card-text class="px-5" style="text-align: center;">
        <p> You have left this browser idle for {{ idleTime / ( 60*1000 ) }} minutes, the browser will logout after:
        </p>
        {{ time / 1000 }} second
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>

import LogOut from "@/components/Logout/Logout.vue"
import API from "@/shared/API";
import apiEndpoints from "@/util/apiEndpoints";
import { mapState } from "vuex";
import UserTypes from "@/util/UserTypes";

const events = "mousemove,keydown,mousedown,touchstart,keypress,scroll,load,touchmove,click,wheel".split(",");
export default {
  name: "IdleComponent",
  data() {
    return {
      model: false,
      time: 10000,
      isIdle: false,
      idleTime: 0,
      idleInterval: null,
      warningTimerId: null,
    }
  },
  computed: {
    ...mapState(["currentUser"]),
    isRadiologist() {
      return this.currentUser && this.currentUser.type === UserTypes.radiology;
    },
  },
  methods: {
    async signOut() {
      await LogOut.methods.signOut();
    },
    checkIdleStatus() {
      const lastActivity = parseInt(localStorage.lastActivity, 10);
      const isCurrentlyIdle = Date.now() - lastActivity > this.idleTime;

      if (isCurrentlyIdle && !this.isIdle) {
        this.isIdle = true;
        this.showWarning();
      }
    },
    getRadIdleTimeInMin() {
      return API.get(apiEndpoints.getRadIdleTimeInMin);
    },
    updateLastActivity() {
      localStorage.lastActivity = Date.now();
    },
    async setupIdleTracking() {
      for (const element of events) {
        window.addEventListener(element, this.updateLastActivity);
      }
      this.updateLastActivity();
      this.idleListenersSet = true;
      const idleTimeInMin = await this.getRadIdleTimeInMin();
      this.idleTime = idleTimeInMin.data.radIdleTimeInMinutes * 60 * 1000;
      this.idleInterval = setInterval(this.checkIdleStatus, 1000);
      console.log("Idle tracking set up for Radiologist.");
    },
    cleanupIdleTracking() {
      for (const element of events) {
        window.removeEventListener(element, this.updateLastActivity);
      }
      clearInterval(this.idleInterval);
      this.idleInterval = null;
      this.idleListenersSet = false;
      this.isIdle = false;
      this.idleTime = 0;
      console.log("Idle tracking cleaned up.");
    },
    showWarning() {
      this.model = true;
      this.time = 10000;

      this.warningTimerId = setInterval(async () => {
        console.log(this.time, this.isIdleNow());
        this.time -= 1000;

        if (!this.isIdleNow()) {
          clearInterval(this.warningTimerId);
          this.model = false;
          this.isIdle = false;
          return;
        }

        if (this.time <= 0) {
          clearInterval(this.warningTimerId);
          await this.signOut();
        }
      }, 1000);
    },
    isIdleNow() {
      const lastActivity = parseInt(localStorage.lastActivity, 10);
      return Date.now() - lastActivity > this.idleTime;
    },
  },
  async mounted() {
    await this.setupIdleTracking();
  },
  beforeDestroy() {
    this.cleanupIdleTracking();
  },
}
</script>

<style scoped>

</style>